import { render, staticRenderFns } from "./DomainEditor.vue?vue&type=template&id=2d944282&scoped=true"
import script from "./DomainEditor.vue?vue&type=script&lang=js"
export * from "./DomainEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d944282",
  null
  
)

export default component.exports